import { useId } from "react";

interface ErrorMessageProps {
  content: string;
  retryable: boolean;
  onRetry?: () => void;
  primaryColor: string;
}

export function ErrorMessage({
  content,
  retryable,
  onRetry,
  primaryColor,
}: ErrorMessageProps) {
  const buttonId = useId();
  const buttonClass = `error-retry-button-${buttonId.replace(/:/g, "-")}`;

  return (
    <>
      <style>
        {`.${buttonClass} {
          --primary-color: ${primaryColor};
        }
        .${buttonClass}:hover {
          background-color: var(--primary-color);
          color: white;
        }
        .${buttonClass}:focus-visible {
          outline: 2px solid var(--primary-color);
          outline-offset: 2px;
        }`}
      </style>
      <div className="flex flex-col gap-3" role="alert" aria-live="polite">
        <div className="prose prose-sm max-w-none wrap-break-word text-base leading-[1.21] text-black">
          <p className="mb-0 whitespace-pre-wrap leading-[1.21]">{content}</p>
        </div>
        {retryable && onRetry && (
          <button
            id={buttonId}
            onClick={onRetry}
            className={`${buttonClass} self-start rounded-lg border-2 bg-transparent px-4 py-2 text-sm font-medium transition-colors`}
            style={{
              borderColor: primaryColor,
              color: primaryColor,
            }}
            aria-label="Retry sending the previous message"
          >
            Try Again
          </button>
        )}
      </div>
    </>
  );
}
